import React, { Component } from 'react';
import $ from 'jquery';
import { findDOMNode } from 'react-dom';

export default class Hellbound extends Component {

toggle = () => {
    let toggle = findDOMNode(this.refs.toggle);
    $(toggle).toggle();
}

	render() {
		return (
			<div>
                <iframe id="video" ref="toggle" src="https://www.youtube.com/embed/RKBDGSeMhnA" 
                title="Hellbound"></iframe>
				<button
					type="button"
					className="btn hellbound"
					onClick={this.toggle}
				>
					Hellbound
				</button>
			</div>
		);
	}
}
